import styled from 'styled-components'
import { breakpoints } from '../../constants/breakpoints.constants'
import FontAwesome from 'react-fontawesome'

export const StyledContainerReverseRounded = styled.div`
	padding: 5px 7px;
	position: absolute;
	z-index: 2;
	top: 18%;
	right: 40px;
	transform: translate(0, -50%);
	width: 45px;
	height: 45px;
	border: 1px solid #666;
	border-radius: 100%;
	background: #fff;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 37px;
		padding: 5px 4px;
		background: none;
		border-radius: 0;
		border: 0;
		cursor: pointer;
		position: unset;
		transform: translate(0, 0);
	}
`

export const InputSearchCitiesContainer = styled.div`
	flex-direction: column;
	align-items: center;
	display: flex;
	width: 100%;
	gap: 10px;
	flex: 2;

	@media (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: ${props =>
		JSON.parse(props.isrooturl) ? 'column' : 'row'};
	}
`

export const InputSearchDateContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	flex: 1.5;
	gap: 10px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: row;
	}
`

export const StyledIconFontAwesome = styled(FontAwesome)`
	position: absolute;
	padding: 25px;
	transform: rotate(270deg);
	right: 15px;
	top: 30px;
	border: 1px solid #517abc;
	background-color: #fff;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${props => props.isIframe ? '#FFFFFF' : '#517abc'};
	height: 40px;
	width: 20px;
	font-size: 22px;
	border-radius: 50%;
	cursor: pointer;

	@media (min-width: ${breakpoints.MOBILE}px) {
		${props =>
		JSON.parse(props.isrooturl)
			? `
				position: absolute;
				padding: 25px;
				transform: rotate(270deg);
				right: 15px;
				top: 30px;
				border: 1px solid #517abc;
				background-color: #fff;
			`
			: `
				position: relative;
				padding: 0;
				transform: rotate(0deg);
				right: 0px;
				top: 0px;
				border: none;
				background-color: transparent;
			`};
	}
`

export const SearchContainer = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	align-items: center;
	flex: 1;
	gap: 10px;
	padding: 10px;

	${props => props.isIframe && 'background-color: var(--background-confirm-primary);'}

	@media (min-width: ${breakpoints.MOBILE}px) {
		flex-direction: ${props =>
		JSON.parse(props.isrooturl) ? 'column' : 'row'};
	}
`

export const InputSearchCity = styled.div`
	flex: 2;
	width: 100%;
	min-width: 200px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-bottom: 0px;
	}
`

export const InputSearchDate = styled.div`
	flex: 1.5;
	width: 100%;

	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-bottom: 0px;
	}
`

export const OriginOptionLabel = styled.span`
	display: block;
	padding-left: ${props => (props.isTerminal ? '16px' : '0')};
	font-weight: ${props => (props.isCity ? 'bold' : 'normal')};
`

export const BtnSearchTrip = styled.div`
	flex: 0.8;
	width: 100%;

	@media (min-width: ${breakpoints.MOBILE}px) {

		> button {
			width: 100%;
		}
	}
`
